import { styled } from '@mui/material';

export const Styles = {
  PriceContainer: styled('div')(({ theme }) => ({
    flexDirection: 'row',
    alignSelf: 'end'
  })),

  PriceImage: styled('img')(({ theme }) => ({
    width: '65%',
    height: '45px',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
      marginLeft: '20px'
    }
  })),

  TextContainer: styled('div')<{ bgImg?: string }>(({ bgImg }) => ({
    flexShrink: 1,
    background: `url(${bgImg}) left top no-repeat`,
    backgroundSize: 'cover',
    paddingTop: '3px',
    paddingBottom: '6px',
    paddingRight: '5px',
    paddingLeft: '35px',
    textAlign: 'right',
    color: 'white'
  })),

  CategoryText: styled('p')<{ textSize: string }>(({ theme, textSize }) => ({
    fontSize: textSize,
    margin: '0'
  })),

  PricePrefixText: styled('p')(({ theme }) => ({
    fontSize: '11px',
    margin: '0',
    opacity: 0.9,
    lineHeight: '1.2'
  })),

  PriceText: styled('p')<{
    textSize: string;
    marginTop: string;
    marginBottom: string;
  }>(({ theme, textSize, marginBottom, marginTop }) => ({
    fontSize: textSize,
    marginTop: marginTop || '0',
    marginBottom: marginBottom || '0'
  }))
};
